<template>
  <div v-if="(value[0] && value[0].type) || value.length > 1" class="space-y-4">
    <InteriorAreaForm
      v-for="(area, index) in value"
      :key="area.id"
      :value="area"
      :index="index"
      @input="(area) => updateArea(area, index)"
      @delete="(index) => deleteArea(index)"
    />
    <AddButton @click="addArea" />
  </div>
  <InteriorAreaForm
    v-else-if="value[0] && value[0].id"
    :value="value[0]"
    :index="0"
    @input="(area) => updateArea(area, 0)"
    @delete="(index) => deleteArea(index)"
  />
  <AddButton v-else @click="addArea" />
</template>

<script>
import AccordionMixin from "./AccordionMixin.vue";
import InteriorAreaForm from "../AreaForms/InteriorAreaForm.vue";
import AddButton from "../ui/AddButton.vue";

export default {
  name: "InteriorAreaAccordion",

  components: {
    InteriorAreaForm,
    AddButton,
  },

  mixins: [AccordionMixin],

  methods: {
    newArea() {
      return {};
    },
  },
};
</script>
